module.exports = __webpack_public_path__ + "static/img/MEL.b7a84f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MEL.svg
// module id = rZgR
// module chunks = 1